import React from "react";
import PropTypes from "prop-types";
import authActions from "../../redux/futures/auth/actions";
import _ from "lodash";
import { connect } from "react-redux";
import baseHelper from "../../helpers/BaseHelper";
import appConst from "../../config/const";
import queryString from "query-string";
import Input from "../../components/Input";
import { NavLink } from "react-router-dom";

import * as types from "../../redux/futures/auth/types";
import i18n from "../../i18n";
import LadiIframe from "./LadiIframe";
import PoweredBy from "../../components/PoweredBy";
import LadiLanguage from "../../components/LadiLanguage";
import LadiAppLogo from "../../components/LadiAppLogo";
import { isMobile } from 'react-device-detect';


class Verify2FA extends React.Component {
    static propTypes = {
        code: PropTypes.string,
    };

    constructor(props) {
        super(props);

        const parsed = queryString.parse(this.props.location.search);
        let verify_type = appConst.VERIFY_2FA_TYPE.TOTP;

        let phone = '';
        let countDownTime = 60;
        let exp_time = 1;
        let token = false;
        if (parsed.verify_type && parsed.verify_type != '') {
            verify_type = parsed.verify_type;
        }

        if (parsed.phone && parsed.phone != '') {
            phone = parsed.phone;
        }
        if (parsed.exp_time && parsed.exp_time != '') {
            exp_time = parsed.exp_time;
        }

        if (parsed.token && parsed.token != '') {
            token = parsed.token;
        }

        this.state = {
            verify_type,

            phone,
            user: false,
            code: "",
            countDownTime,
            exp_time,
            token,
            search: this.props.location.search,
            loading: false,
            codeAuth: ['', '', '', '', '', ''],
            classNormal: "ladiui btn btn-primary full-width",
            classLoading: "ladiui loader btn btn-primary full-width",
            classApply: "ladiui btn btn-primary full-width",
        };
        this.inputsRef = [React.createRef(), React.createRef(), React.createRef(), React.createRef(), React.createRef(), React.createRef()];
        this.ref = React.createRef();
    }
    componentDidMount() {
        this.timerId = setInterval(() => {
            this.setState((prevState) => ({
                countDownTime: prevState.countDownTime - 1,
            }));
        }, 1000);
    }
    componentWillMount() {
        this.redirectAuth(this.props);
    }
    redirectAuth(props) {
        const tokenCookie = baseHelper.getCookie(appConst.LADI_UID_TOKEN);
        const { token } = this.state;
        if (!tokenCookie && !token) {
            props.history.push("/signin");
        }
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.action == types.VERIFY_2FA) {
            if (nextProps.status) {
                // const user = nextProps.data;
                // console.log(' nextProps.data = ',nextProps.data)
                // this.setState({ verify_type, user });
                // window.LadiUI.showErrorMessage(i18n.t('BASE.NOTIFICATION'), nextProps.message, 'OK');
            } else {
                window.LadiUI.showErrorMessage(i18n.t('BASE.NOTIFICATION'), nextProps.message, 'OK');
            }
            this.setState({
                loading: false,
                classApply: this.state.classNormal,
            });
        }
        if (nextProps.action == types.RESEND_OTP_2FA) {
            if (nextProps.status) {
                const { exp_time } = nextProps.data;
                // const user = nextProps.data;
                // console.log(' nextProps.data = ',nextProps.data)
                this.setState({ exp_time: Math.ceil(exp_time), countDownTime: 60 }, () => {

                    clearInterval(this.timerId);
                    this.timerId = setInterval(() => {
                        this.setState((prevState) => ({
                            countDownTime: prevState.countDownTime - 1,
                        }));
                    }, 1000);
                });
                // window.LadiUI.showErrorMessage(i18n.t('BASE.NOTIFICATION'), nextProps.message, 'OK');
            } else {
                window.LadiUI.showErrorMessage(i18n.t('BASE.NOTIFICATION'), nextProps.message, 'OK');
            }
            this.setState({
                loading: false,
                classApply: this.state.classNormal,
            });
        }
    }

    componentWillUnmount() {
        clearInterval(this.timerId);
    }

    componentDidUpdate() {
        window.LadiUI.init();
        if (this.state.countDownTime <= 0 && this.timerId) {
            clearInterval(this.timerId);
        }

    }

    submit = (code) => {

        let errors = [];
        const inputsRef = _.compact(Array.from(this.inputsRef));
        _.map(inputsRef, (ref) => {
            if (ref.validate) {
                errors = errors.concat(ref.validate());
            }
        });

        _.compact(errors);
        if (errors.length > 0) {
            const errorMessage = errors.join("<br/>");
            window.LadiUI.toast("error", "", errorMessage);
            return;
        }

        const { token } = this.state;
        const jsonData = {
            token: code,
            search: this.state.search,
            custom_auth: token
        };
        console.log('jsonData', jsonData)
        this.props.submitOtp2FA(jsonData);
        this.state.loading = true;
        this.state.classApply = this.state.classLoading;
    };

    onChangeInput = (event) => {
        this.setState({
            code: event.target.value,
        });
    };

    resendCode = () => {
        const { token, countDownTime } = this.state;
        if (countDownTime > 0) {
            return;
        }
        const jsonData = {

            custom_auth: token
        };
        this.props.resendOtp2FA(jsonData);
    }

    // Xử lý khi nhập số
    handleInputCode = (index, e) => {
        const value = e.target.value.replace(/[^0-9]/g, '');
        if (value.length > 1) return;

        const newCode = [...this.state.codeAuth];
        newCode[index - 1] = value;
        this.setState({ codeAuth: newCode });

        if (value && index < 6) {
            this.inputsRef[index].current.focus();
        }
    };

    handleKeyDown = (index, e) => {
        if (e.key === 'Backspace' && !this.state.codeAuth[index - 1] && index > 1) {
            this.inputsRef[index - 2].current.focus();
        }
    };

    handlePaste = (e) => {
        const paste = e.clipboardData.getData('text');
        if (paste.length === 6 && /^\d+$/.test(paste)) {
            const newCode = paste.split('');
            this.setState({ codeAuth: newCode });
            this.inputsRef[5].current.focus();
            e.preventDefault();
        }
    };

    handleConfirmActive = () => {
        let otpCode = this.state.codeAuth.join('');
        console.log('otpCode', otpCode)
        if (otpCode) {
            this.submit(otpCode);
        }
        this.setState({ codeAuth: ['', '', '', '', '', ''] });
    }


    render() {
        const { code, countDownTime, verify_type, phone } = this.state;
        // console.log(email);
        const search = this.props.location.search;
        return (
            <div className="ladiui auth">

                <div className="ladiui-login-wrap no-frame">
                    <LadiAppLogo />

                    <div className="ladiui-login" style={{ width: '500px', paddingTop: "24px" }} id="twofa-container">

                        <div style={{ textAlign: "center" }}>
                            <img src='https://w.ladicdn.com/ladiui/icons/ldicon-new-google-auth.svg' />

                        </div>

                        <div className="ladiui-login-form create-user-form">
                            <div className="ladiui-form">
                                <div className='block-step'>
                                    {
                                        isMobile ?
                                            <div className='title-step mobile'>
                                                <div><strong>{i18n.t('TWO_FA_AUTH.2FA_TITLE_1')}</strong> {i18n.t('TWO_FA_AUTH.2FA_TITLE_2')}</div>
                                                <div>{i18n.t('TWO_FA_AUTH.2FA_TITLE_3')} <strong>{i18n.t('TWO_FA_AUTH.2FA_TITLE_4')}</strong></div>
                                            </div>
                                            :
                                            <div className='title-step'>
                                                <div><p>{i18n.t('TWO_FA_AUTH.2FA_TITLE_1')}</p> {i18n.t('TWO_FA_AUTH.2FA_TITLE_2')}</div>
                                                <div>{i18n.t('TWO_FA_AUTH.2FA_TITLE_3')} <p>{i18n.t('TWO_FA_AUTH.2FA_TITLE_4')}</p></div>
                                            </div>
                                    }


                                    <div className='block-enter-authen-code'>
                                        <div className='code-container' onPaste={this.handlePaste}>
                                            <input type="text" className="code-input" maxLength="1" value={this.state.codeAuth[0]} onChange={(e) => this.handleInputCode(1, e)} ref={this.inputsRef[0]} onKeyDown={(e) => this.handleKeyDown(1, e)} />
                                            <input type="text" className="code-input" maxLength="1" value={this.state.codeAuth[1]} onChange={(e) => this.handleInputCode(2, e)} ref={this.inputsRef[1]} onKeyDown={(e) => this.handleKeyDown(2, e)} />
                                            <input type="text" className="code-input" maxLength="1" value={this.state.codeAuth[2]} onChange={(e) => this.handleInputCode(3, e)} ref={this.inputsRef[2]} onKeyDown={(e) => this.handleKeyDown(3, e)} />
                                            <input type="text" className="code-input" maxLength="1" value={this.state.codeAuth[3]} onChange={(e) => this.handleInputCode(4, e)} ref={this.inputsRef[3]} onKeyDown={(e) => this.handleKeyDown(4, e)} />
                                            <input type="text" className="code-input" maxLength="1" value={this.state.codeAuth[4]} onChange={(e) => this.handleInputCode(5, e)} ref={this.inputsRef[4]} onKeyDown={(e) => this.handleKeyDown(5, e)} />
                                            <input type="text" className="code-input" maxLength="1" value={this.state.codeAuth[5]} onChange={(e) => this.handleInputCode(6, e)} ref={this.inputsRef[5]} onKeyDown={(e) => this.handleKeyDown(6, e)} />
                                        </div>
                                    </div>
                                </div>
                                <div className="ladiui modal-footer justify-end custom-v4 flex-col gap-16" style={{ marginTop: '10px', paddingBottom: "unset" }}>
                                    <button
                                        className={`ladiui btn btn-primary w100`}
                                        onClick={() => this.handleConfirmActive()}
                                        style={{ width: '328px', height: '48px' }}
                                        disabled={this.state.codeAuth.some(code => code === '')}
                                    >
                                        {i18n.t('TWO_FA_AUTH.CONFIRM')}
                                    </button>
                                </div>
                            </div>

                        </div>

                    </div>
                    <PoweredBy />
                </div>
            </div>
        );
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        resendOtp2FA: (data) =>
            dispatch(authActions.resendOtp2FA(data)),
        submitOtp2FA: (data) =>
            dispatch(authActions.submitOtp2FA(data)),
    };
};

const mapStateToProps = (state) => ({ ...state.auth });

export default connect(mapStateToProps, mapDispatchToProps)(Verify2FA);
